import { CLASSES, IS_SAFARI } from "../helpers/consts";
import { getNewLottieAnim } from "../helpers/lottie";
import { scaleBlockToScreen } from "../helpers/video-helpers";
import { playHeroLottie } from "./home/hero";

import сustomPageScroll from '../components/custom-scroll';

// Helper function to parse URL query parameters
function getQueryParam(param) {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(param);
}

const loader = document.querySelector('.js-loader');
const lottieEl = document.querySelector('.js-loader-lottie');
let anim = null;

export default () => {
	if (!loader || !lottieEl) return;

	// Disable loader on mobile devices based on screen width
	if (window.innerWidth < 768 || getQueryParam('noloader')) {
		loader.remove(); // This will remove the loader from the DOM
		return; // Exit the function early to avoid initializing animation
	}

	anim = getNewLottieAnim(lottieEl, {
		renderer: IS_SAFARI ? 'canvas' : 'svg',
		autoplay: true,
		loop: true
	});

	scaleBlockToScreen(loader, 'fixed');
}

export const closeLoader = () => {
	let isFirstLoaded = sessionStorage.getItem('isFirstLoaded');
	if (!loader || !lottieEl) return; // Check if elements are already removed or not present
	const delay = isFirstLoaded === 'true' ? 500 : 3700;
	sessionStorage.setItem('isFirstLoaded', `true`);

	setTimeout(() => {
		сustomPageScroll.checkScrollTo();
		setTimeout(() => {
			if (loader) {
				loader.classList.remove(CLASSES.active);
				if (anim) anim.pause();
				playHeroLottie();
			}
		}, 10);
	}, delay);
};
